import React, { FC, ReactNode } from 'react';
import { StickyContainer } from 'react-sticky';
import styled, { css } from 'styled-components';
import { Scrollable } from 'components/styles/scrollable';
import { Content } from './content';
import { Footer } from './footer';
import { Header } from './header';
import { LeftMenu } from './left-menu';
import { Peel } from './peel';

interface Props {
  $gray?: boolean;
}

const PageComponent = styled(StickyContainer).attrs({ id: 'page' })<Props>`
  flex: 1 1 100%;
  display: flex;
  flex-direction: column;
  height: 100vh;

  ${Scrollable};

  ${({ $gray }) => css`
    background: ${$gray ? 'var(--coolest-gray-10)' : 'var(--white-100)'};
  `};

  ${Header} {
    padding: var(--layout-01) var(--layout-02) 0;
    width: 100%;
    box-shadow: var(--shadow-02);
    z-index: var(--zindex-layer-${({ theme }) => `0${theme.header.layer}`});
    flex: 0 0 auto;
    position: relative;
  }
`;

type Page = typeof PageComponent & {
  Header: typeof Header;
  Content: typeof Content;
  Peel: typeof Peel;
  Footer: typeof Footer;
  LeftMenu: typeof LeftMenu;
};

const Page: Page = PageComponent as any;

Page.Header = Header;
Page.Content = Content;
Page.Peel = Peel;
Page.Footer = Footer;
Page.LeftMenu = LeftMenu;

export const HeaderWithIconTitle: FC<{
  icon: ReactNode;
  title: string | JSX.Element;
}> = ({ icon, title }) => {
  return (
    <Page.Header.Title>
      <Page.Header.Title.Icon>{icon}</Page.Header.Title.Icon>
      <Page.Header.Title.Text>{title}</Page.Header.Title.Text>
    </Page.Header.Title>
  );
};

export { Page };
